import { useEffect } from 'react';

/**
 * 공지사항 팝업 모달
 * @param {Object} notice - 공지사항 데이터
 * @param {boolean} isOpen - 모달 열림 여부
 * @param {Function} onConfirm - 확인 버튼 클릭 시 호출되는 함수
 */
function NoticePopupModal({ notice, isOpen, onConfirm }) {
  useEffect(() => {
    // 모달이 열리면 배경 스크롤 방지
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen || !notice) return null;

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm(notice.id);
    }
  };

  // 중요도에 따른 스타일
  const priorityStyles = {
    high: 'border-red-500 bg-red-50',
    normal: 'border-orange-500 bg-orange-50',
    low: 'border-blue-500 bg-blue-50'
  };

  const priorityStyle = priorityStyles[notice.priority] || priorityStyles.normal;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-[300] flex items-center justify-center p-4">
      <div className={`bg-white rounded-lg shadow-xl max-w-2xl w-full border-2 ${priorityStyle}`}>
        {/* 헤더 */}
        <div className="px-6 py-4 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <svg className="w-5 h-5 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
              </svg>
              <h2 className="text-xl font-bold text-gray-800">공지사항</h2>
              {notice.priority === 'high' && (
                <span className="px-2 py-0.5 bg-red-500 text-white text-xs font-semibold rounded">
                  중요
                </span>
              )}
            </div>
            {notice.createdAt && (
              <span className="text-xs text-gray-500">
                {new Date(notice.createdAt).toLocaleDateString('ko-KR')}
              </span>
            )}
          </div>
        </div>

        {/* 내용 */}
        <div className="px-6 py-4 max-h-[60vh] overflow-y-auto">
          <h3 className="text-lg font-semibold text-gray-800 mb-3">
            {notice.title}
          </h3>
          <div className="text-gray-700 whitespace-pre-wrap leading-relaxed">
            {notice.content}
          </div>
        </div>

        {/* 하단 버튼 */}
        <div className="px-6 py-4 border-t border-gray-200 flex justify-end">
          <button
            onClick={handleConfirm}
            className="px-6 py-2 bg-orange-500 text-white rounded-lg text-sm font-semibold hover:bg-orange-600 transition-colors"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
}

export default NoticePopupModal;
